import { useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { SignupValidation } from '../../components/Validation';
import { SignupApi } from '../../apis';
import MandatoryLabel from '../../components/common/label';
import { InputErrorMessage } from '../../components/errorMessages';
import { EditProfileLoader } from '../../components/common/loader';
import { commonUsedClass, mobileLoginViewtalwind,  } from './MobileLoginTalwind';

export default function SignUpForm() {
    const [loader, setLoader] = useState(false);
    const [passwordType, setPasswordType] = useState('password');
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: { email: '', name: '', password: '', terms: false },
        validationSchema: SignupValidation,
        onSubmit: async (values) => {
            const { name, email, password, terms } = values;
            try {
                setLoader(true);
                const res = await SignupApi({
                    email,
                    isActive: true,
                    password,
                    isTermsAccepted: true,
                });
                if (res.status === 200) {
                    toast.success(res.data.message);
                    navigate('/sign-in');
                }
            } catch (error) {
                setLoader(false);
                const message = error?.response?.data?.message || error?.response?.statusText || "Something went wrong";
                toast.error(message, { id: 'error' });
            }
        },
    });

    const handleChange = (e) => {
        e.preventDefault();
        formik.handleChange(e);
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        formik.setFieldValue(name, checked);
    };

    const togglePasswordType = () => {
        setPasswordType((prev) => (prev === 'password' ? 'text' : 'password'));
    };

    return (
        <form className="signInForm" onSubmit={formik.handleSubmit}>
            <div className="relative">
                <MandatoryLabel title="Email" />
                <input
                    type="text"
                    name="email"
                    id="email"
                    placeholder="Email"
                    className={`form-control transparent-input-border ${formik.touched.email && formik.errors.email ? 'border-danger' : ''}`}
                    value={formik.values.email}
                    onChange={handleChange}
                />
                <InputErrorMessage error={formik.touched.email && formik.errors.email} />
            </div>

            <div className="relative">
                <MandatoryLabel title="Password" />
                <div className="relative">
                    <input
                        type={passwordType}
                        name="password"
                        id="password"
                        placeholder="Password"
                        className={`form-control transparent-input-border ${formik.touched.password && formik.errors.password ? 'border-danger' : ''}`}
                        value={formik.values.password}
                        onChange={handleChange}
                    />
                    <div
                        className="absolute top-1/2 -translate-y-1/2 right-4 p-2 cursor-pointer"
                        onClick={togglePasswordType}
                    >
                        {passwordType === 'password' ? <IoEyeOff /> : <IoEye />}
                    </div>
                </div>
               <InputErrorMessage error={formik.touched.password && formik.errors.password} />
                
            </div>

            <div className="termsCondition">
                <div className="flex items-start ml-[2px]">
                    <input
                        type="checkbox"
                        id="terms"
                        name="terms"
                        className="mt-0.5"
                        onChange={handleCheckboxChange}
                        checked={formik.values.terms}
                    />
                    <label
                        htmlFor="terms"
                        className="text-xs text-primary_v2 ms-1 select-none"
                    >
                        I agree with the
                        <a
                            className="text-blue-600 hover:text-blue-800"
                            href="https://modoapp.in/about/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Terms of Service & Privacy Policy
                        </a>
                    </label>
                </div>
                {(formik.touched.terms && formik.errors.terms) && <InputErrorMessage error={formik.touched.terms && formik.errors.terms} />}
                
            </div>

            <div className="signButton !mt-6 space-y-2">
                <button className={commonUsedClass.btncon} type="submit">
                    {!loader ? 'Sign Up' : <div className="text-xs"><EditProfileLoader /></div>}
                </button>
            <div
              className={mobileLoginViewtalwind.DLcon}
            >
             <span className={mobileLoginViewtalwind.DLNormalTxt}>Have an account? </span>  <span className={mobileLoginViewtalwind.DLLinkTxt}  onClick={() => navigate('/log-in')}>Log in</span>
            </div>
            </div>
        </form>
    );
}
